export const handleAddressValidation = async ({
  formData,
  setFormData,
  setModalOpen,
  setModalHeading,
  setModalMessage,
  setValidationResult,
  setPendingUpdatedData,
  setShowAddressModal,
  validateSingleAddress,
  setUboAddressChanges,
  setCurrentUboIndex
}) => {
  try {
    const changed = [];
    const formUbos = formData.ubos || [];
    const originalUbos = JSON.parse(JSON.stringify(formUbos));
    let updatedData = JSON.parse(JSON.stringify(formData));
    let finalData = JSON.parse(JSON.stringify(formData));

    for (let i = 0; i < formUbos.length; i++) {
      const ubo = formUbos[i];

      // ✅ Skip if already validated or discarded
      if (
        ubo.addressValidationStatus === "kept" ||
        ubo.addressValidationStatus === "discarded" ||
        ubo.validateAddressStatus === "Validated"
      ) continue;

      const originalAddress = ubo.data;
      if (!originalAddress) continue;

      const validatedAddress = await validateSingleAddress(originalAddress);
      console.log("validatedAddress in validator:", validatedAddress);

      if (validatedAddress === "No Response") {
        console.warn("Loqate returned no data");
        setUboAddressChanges(changed);
        setCurrentUboIndex(0);
        setModalOpen(false);
        setModalHeading("");
        setModalMessage(null);
        setValidationResult(null);
        setPendingUpdatedData(validatedAddress);
        setShowAddressModal(true);
      }

      const keys = [
        "addressLine1", "addressLine2", "addressLine3", "uboaddressLine1",
        "uboaddressLine2", "uboaddressLine3", "ubocountry", "ubocity", "ubopostalCode",
        "city", "state", "postcode", "postCode",
        "country", "countryOfIncorporation", "CountryName",
        "uboCharityAddress", "uboRegisteredOfficeAddress",
        "uboBusinessAddress",
        "uboRegisteredAddress", "uboLegalPersonRegisteredOfficeAddress", "uboAddress"
      ];

      const hasChange = keys.some(
        key => originalAddress?.[key] !== validatedAddress?.[key]
      );

      if (hasChange) {
        changed.push({
          index: i,
          id: ubo.id,
          formData: originalAddress,
          updatedData: validatedAddress
        });

        updatedData.ubos[i].data = validatedAddress;
      }
    }

    if (changed.length === 0) {
      return { valid: true, data: formData };
    }

    // Setup modal and handlers
    setUboAddressChanges(changed);
    setCurrentUboIndex(0);
    setModalOpen(false);
    setModalHeading("");
    setModalMessage(null);
    setValidationResult(null);
    setPendingUpdatedData(updatedData);
    setShowAddressModal(true);

    return new Promise((resolve) => {
      let currentIndex = 0;

      const proceedToNextStep = () => {
        const { index, updatedData: newAddress } = changed[currentIndex];
        const originalAddress = originalUbos[index].data;

        const handleContinue = () => {
          if (newAddress !== "No Response") {
            // Valid address -> Replace
            setFormData(prev => {
              const updatedUbos = [...(prev.ubos || [])];
              updatedUbos[index].data = newAddress;
              updatedUbos[index].addressValidationStatus = "kept";
              updatedUbos[index].validateAddressStatus = "Validated";
              localStorage.setItem("corporateFormData", JSON.stringify(updatedUbos));
              return { ...prev, ubos: updatedUbos };
            });

            finalData.ubos[index].data = newAddress;
            finalData.ubos[index].addressValidationStatus = "kept";
            finalData.ubos[index].validateAddressStatus = "Validated";
          } else {
            // No response -> fallback to original, treat as discard
            setFormData(prev => {
              const updatedUbos = [...(prev.ubos || [])];
              updatedUbos[index].data = originalAddress;
              updatedUbos[index].addressValidationStatus = "discarded";
              updatedUbos[index].validateAddressStatus = "Validated";
              return { ...prev, ubos: updatedUbos };
            });

            finalData.ubos[index].data = originalAddress;
            finalData.ubos[index].addressValidationStatus = "discarded";
            finalData.ubos[index].validateAddressStatus = "Validated";
          }

          // Move to next
          if (currentIndex + 1 < changed.length) {
            currentIndex += 1;
            setCurrentUboIndex(currentIndex);
            proceedToNextStep();
          } else {
            setShowAddressModal(false);
            resolve({ valid: true, data: finalData });
          }
        };

        const handleDiscard = () => {
          // Always fallback to original
          setFormData(prev => {
            const updatedUbos = [...(prev.ubos || [])];
            updatedUbos[index].data = originalAddress;
            updatedUbos[index].addressValidationStatus = "discarded";
            updatedUbos[index].validateAddressStatus = "Validated";
            return { ...prev, ubos: updatedUbos };
          });

          finalData.ubos[index].data = originalAddress;
          finalData.ubos[index].addressValidationStatus = "discarded";
          finalData.ubos[index].validateAddressStatus = "Validated";

          // Move to next
          if (currentIndex + 1 < changed.length) {
            currentIndex += 1;
            setCurrentUboIndex(currentIndex);
            proceedToNextStep();
          } else {
            setShowAddressModal(false);
            resolve({ valid: true, data: finalData });
          }
        };

        setValidationResult({ handleContinue, handleDiscard });
      };

      proceedToNextStep();
    });


  } catch (error) {
    console.error("❌ Address validation failed:", error);
    setModalHeading("Address Validation Error");
    setModalMessage("An error occurred while validating the address. Please try again.");
    setModalOpen(true);

    return { valid: false, data: null };
  }
};



// utils/addressValidatorInd.js

export const handleAddressValidationNonUbo = async ({
  formData,
  validateSingleAddress,
  setFormData,
  setModalOpen,
  setModalHeading,
  setModalMessage,
  setValidationResult,
  setPendingUpdatedData,
  setShowAddressModal
}) => {
  try {
    console.log("formData in addressValidator:", formData);

    const originalAddress = JSON.parse(JSON.stringify(formData));
    const validatedAddress = await validateSingleAddress(formData);

    // If Loqate returned our "No Response" sentinel, short-circuit here:
    if (validatedAddress === "No Response") {
      console.warn("Loqate returned no data");
      setModalOpen(false);
      setModalHeading("");
      setModalMessage(null);
      setValidationResult(null);
      setPendingUpdatedData(validatedAddress);
      setShowAddressModal(true);
      
    }

    const keys = [
      "addressLine1", "addressLine2", "addressLine3",
      "city", "state", "postcode", "postCode",
      "country", "countryOfIncorporation", "CountryName",
      "uboCharityAddress", "uboRegisteredOfficeAddress",
      "uboBusinessAddress",
      "uboRegisteredAddress", "uboLegalPersonRegisteredOfficeAddress", "uboAddress"
    ];

    const hasChange = keys.some(
      key => originalAddress?.[key] !== validatedAddress?.[key]
    );

    if (!hasChange) {
      return { valid: true, data: formData };
    }

    // Setup modal and handlers
    setModalOpen(false);
    setModalHeading("");
    setModalMessage(null);
    setValidationResult(null);
    setPendingUpdatedData(validatedAddress);
    setShowAddressModal(true);

    return new Promise((resolve) => {
      const handleContinue = () => {
        if (validatedAddress !== "No Response") {
          setFormData(validatedAddress);
          setShowAddressModal(false);
          resolve({ valid: true, data: validatedAddress });
        } else {
          setFormData(formData);
          setShowAddressModal(false);
          resolve({ valid: true, data: formData });
        }
        
      };

      const handleDiscard = () => {
        setShowAddressModal(false);
        resolve({ valid: true, data: formData });
      };

      setValidationResult({ handleContinue, handleDiscard });
    });

  } catch (error) {
    console.error("Address validation failed:", error);
    setModalHeading("Address Validation Error");
    setModalMessage("An error occurred while validating the address. Please try again.");
    setModalOpen(true);

    return { valid: false, data: null };
  }
};


export const handleAddressValidationManagers = async ({
  managers,
  setManagers,
  setModalOpen,
  setModalHeading,
  setModalMessage,
  setManagerValidationResult,
  setPendingUpdatedManagers,
  setShowManagerAddressModal,
  validateSingleAddress,
  setManagerAddressChanges,
  setCurrentManagerIndex
}) => {
  try {
    const changed = [];
    const originalManagers = JSON.parse(JSON.stringify(managers));
    let updatedManagers = JSON.parse(JSON.stringify(managers));
    let finalManagers = JSON.parse(JSON.stringify(managers));

    for (let i = 0; i < managers.length; i++) {
      const manager = managers[i];

      if (
        manager.addressValidationStatus === "kept" ||
        manager.addressValidationStatus === "discarded" ||
        manager.validateAddressStatus === "Validated"
      ) continue;

      const isIndividual = manager.managerEntity === "Individual";
      const originalAddress = isIndividual
        ? manager.data
        : manager?.data?.uboState?.data;

      if (!originalAddress) continue;

      const validatedAddress = await validateSingleAddress(originalAddress);
      console.log("validatedAddress (manager):", validatedAddress);

      const keys = [
        "addressLine1", "addressLine2", "addressLine3",
        "city", "state", "postcode", "postCode",
        "country", "countryOfIncorporation", "CountryName",
        "uboCharityAddress", "uboRegisteredOfficeAddress",
        "uboBusinessAddress",
        "uboRegisteredAddress", "uboLegalPersonRegisteredOfficeAddress", "uboAddress"
      ];

      const hasChange = keys.some(
        key => originalAddress?.[key] !== validatedAddress?.[key]
      );

      if (hasChange || validatedAddress === "No Response") {
        changed.push({
          index: i,
          id: manager.id,
          formData: originalAddress,
          updatedData: validatedAddress
        });

        if (hasChange && validatedAddress !== "No Response") {
          if (isIndividual) {
            updatedManagers[i].data = validatedAddress;
          } else {
            updatedManagers[i].data.uboState.data = validatedAddress;
          }
        }
      }
    }

    if (changed.length === 0) {
      return { valid: true, data: managers };
    }

    setManagerAddressChanges(changed);
    setCurrentManagerIndex(0);
    setModalOpen(false);
    setModalHeading("");
    setModalMessage(null);
    setManagerValidationResult(null);
    setPendingUpdatedManagers(updatedManagers);
    setShowManagerAddressModal(true);

    return new Promise((resolve) => {
      let currentIndex = 0;

      const proceedToNext = () => {
        if (currentIndex + 1 < changed.length) {
          currentIndex += 1;
          setCurrentManagerIndex(currentIndex);
        } else {
          setShowManagerAddressModal(false);
          resolve({ valid: true, data: finalManagers });
        }
      };

      const handleContinue = () => {
        const { index, updatedData: newAddress } = changed[currentIndex];
        const isIndividual = managers[index].managerEntity === "Individual";

        if (newAddress !== "No Response") {
          // ✅ Replace with validated address
          setManagers(prev => {
            const updated = [...prev];
            if (isIndividual) {
              updated[index].data = newAddress;
            } else {
              updated[index].data.uboState.data = newAddress;
            }
            updated[index].addressValidationStatus = "kept";
            updated[index].validateAddressStatus = "Validated";
            localStorage.setItem("managers", JSON.stringify(updated));
            return updated;
          });

          if (isIndividual) {
            finalManagers[index].data = newAddress;
          } else {
            finalManagers[index].data.uboState.data = newAddress;
          }
          finalManagers[index].addressValidationStatus = "kept";
          finalManagers[index].validateAddressStatus = "Validated";
        } else {
          // ❌ No Response → fallback to original address
          setManagers(prev => {
            const updated = [...prev];
            if (isIndividual) {
              updated[index].data = originalManagers[index].data;
            } else {
              updated[index].data.uboState.data = originalManagers[index].data.uboState.data;
            }
            updated[index].addressValidationStatus = "discarded";
            updated[index].validateAddressStatus = "Validated";
            return updated;
          });

          if (isIndividual) {
            finalManagers[index].data = originalManagers[index].data;
          } else {
            finalManagers[index].data.uboState.data = originalManagers[index].data.uboState.data;
          }
          finalManagers[index].addressValidationStatus = "discarded";
          finalManagers[index].validateAddressStatus = "Validated";
        }

        proceedToNext();
      };

      const handleDiscard = () => {
        const { index } = changed[currentIndex];
        const isIndividual = managers[index].managerEntity === "Individual";

        setManagers(prev => {
          const updated = [...prev];
          if (isIndividual) {
            updated[index].data = originalManagers[index].data;
          } else {
            updated[index].data.uboState.data = originalManagers[index].data.uboState.data;
          }
          updated[index].addressValidationStatus = "discarded";
          updated[index].validateAddressStatus = "Validated";
          return updated;
        });

        if (isIndividual) {
          finalManagers[index].data = originalManagers[index].data;
        } else {
          finalManagers[index].data.uboState.data = originalManagers[index].data.uboState.data;
        }
        finalManagers[index].addressValidationStatus = "discarded";
        finalManagers[index].validateAddressStatus = "Validated";

        proceedToNext();
      };

      setManagerValidationResult({ handleContinue, handleDiscard });
    });

  } catch (error) {
    console.error("❌ Manager address validation failed:", error);
    setModalHeading("Address Validation Error");
    setModalMessage("An error occurred while validating the manager's address. Please try again.");
    setModalOpen(true);
    return { valid: false, data: null };
  }
};
